import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { S as SelectComponent } from './Select-LSn3KQwG.js';
import { CoreContext } from './context/index.js';

const mapSize = (items, label, outsideLabels) => {
    if (!items)
        return [];
    let formattedOptions = items.map(item => ({
        value: item.label,
        label: item.label,
        disabled: item.disabled,
    }));
    if (!outsideLabels) {
        formattedOptions = [
            {
                value: '',
                label,
                disabled: false,
            },
            ...formattedOptions,
        ];
    }
    return formattedOptions;
};

const Sizes = ({ option, disabled, register, errors }) => {
    var _a;
    const { t } = useTranslation('', { keyPrefix: '' });
    const { data: { siteConfig: { product: { shortSelectLabel = true, outsideLabels = false } = {} }, }, } = useContext(CoreContext);
    const label = shortSelectLabel
        ? option.label
        : t('$common.selectLabel', {
            selectorLabel: option.label,
        });
    return (React.createElement(SelectComponent, { name: option.attribute_code, id: option.attribute_code, register: register, options: disabled ? [] : mapSize(option.values, label, outsideLabels), disabled: disabled || !((_a = option === null || option === void 0 ? void 0 : option.values) === null || _a === void 0 ? void 0 : _a.length), ariaLabel: label, errors: errors, ...(outsideLabels && { label }) }));
};

export { Sizes as S };
//# sourceMappingURL=Sizes-tn0Bbk4S.js.map
